import React from 'react';
import {graphql, Link, useStaticQuery} from 'gatsby';

export default function LegalMenu(): React.JSX.Element {
  const {allMenuItems} = useStaticQuery(graphql`
    query legalMenuData {
      allMenuItems(
        sort: { weight: ASC }
        filter: {
          menu_name: { eq: "legal" }
          id: { glob: "menu-items-menu_link_content:*" }
        }
      ) {
        nodes {
          title
          url
        }
      }
    }
  `);

  return (
    <ul className="au-c-list-horizontal">
      {allMenuItems.nodes.map((link, idx) => (
        <li className="au-c-list-horizontal__item" key={idx}>
          <Link to={link.url} className="ember-view au-c-link au-c-link--secondary">{link.title}</Link>
        </li>
      ))}
    </ul>
  );
}
